var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZetCoinsFilled = function SvgZetCoinsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ZetCoinsFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#596379",
    fillRule: "evenodd",
    d: "M1.493 8a6.507 6.507 0 1 1 13.014 0A6.507 6.507 0 0 1 1.493 8m7.071-1.62H12.1v.998h-1.037V9.62h-.998V7.378H9.02zm-1.809 0H3.901v.998h1.376L3.901 8.622v.998h2.854v-.998H5.38l1.376-1.244zm1.143 2.242h1.455l.463.998H6.984V6.38H8.31l.455.997h-.868v.171h.956l.158.34.26.562H7.898z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ZetCoinsFilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgZetCoinsFilled;